import {Parameter, XslTransformationFile} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalXslTransformationFile extends XslTransformationFile implements Parameter {
	public id?: string;
	public mimetype?: string;

	constructor(data: any) {
		super(data);

		this.id = FunctionHelper.exists(data?.id) ? data.id : "";
		this.mimetype = FunctionHelper.exists(data?.mimetype) ? data.mimetype : "";
	}

	public static getIdDefault(): string {
		return "";
	}

	public static getMimetypeDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalXslTransformationFile {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalXslTransformationFile(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'id': this.id,
			'mimetype': this.mimetype
		};
	}

	public clone(): PortalXslTransformationFile {
		return PortalXslTransformationFile.fromJson(this.toJson());
	}
}